<!-- Link Input -->
<div class="w-full"
     [class.field]="formField">
  @if (routerLink) {
    <a
      id="{{ name }}"
      class="{{ inputClass }}"
      routerLink="{{ routerLink }}">
      @if (iconClass) {
        <i class="{{ iconClass }}"
        ></i>
      }
      @if (label) {
        {{ label | translate }}
      }
    </a>
  }
  @if (href) {
    <a
      id="{{ name }}"
      class="{{ inputClass }}"
      href="{{ href }}"
      target="{{ target }}">
      @if (iconClass) {
        <i class="{{ iconClass }}"
        ></i>
      }
      @if (label) {
        {{ label | translate }}
      }
    </a>
  }
</div>